import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import {SteelTube, steelTubeApi} from "@/api/steelTube";

export interface SteelTubeState {
  steelTubes: SteelTube[];
}

const steelTubeModule: Module<SteelTubeState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      steelTubes: [] as SteelTube[],
    } as SteelTubeState),
  mutations: {
    setSteelTubes(state: SteelTubeState, steelTubes: SteelTube[]): void {
      state.steelTubes = steelTubes;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<SteelTubeState, RootState>
    ): Promise<void> {
      if (!context.state.steelTubes || context.state.steelTubes.length === 0) {
        context.commit("setSteelTubes", await steelTubeApi.list());
      }
    },
    async addSteelTube(
      context: ActionContext<SteelTubeState, RootState>,
      steelTube: SteelTube
    ): Promise<void> {
      await steelTubeApi.add(steelTube)
      context.commit("setSteelTubes", await steelTubeApi.list());
    },
    async editSteelTube(
      context: ActionContext<SteelTubeState, RootState>,
      steelTube: SteelTube
    ): Promise<void> {
      if (steelTube.id) {
        await steelTubeApi.edit(steelTube);
        context.commit("setSteelTubes", await steelTubeApi.list());
      }
    },
    async removeSteelTube(
      context: ActionContext<SteelTubeState, RootState>,
      steelTube: SteelTube
    ): Promise<void> {
      if (steelTube.id) {
        await steelTubeApi.delete(steelTube)
        context.commit("setSteelTubes", await steelTubeApi.list());
      }
    },
  },
};

export default steelTubeModule;
